import React from 'react';
import axios from 'axios';
import {
    Link
  } from 'react-router-dom';
import mmph from 'myanmar-phonenumber';
var moment = require('moment');

class AccPage extends React.Component {
    constructor(props) {
        super(props)
        this.state = { step: "login", message : "", form : {username: '', phone: '',verify_code: '', password: '' },id:"",username:"",phone:"",created_at:"",league_points:"0",max_league_points:"0",rank:""};
        this.validatePhone      = this.validatePhone.bind(this);
        this.userLogout         = this.userLogout.bind(this);

        if(props.match.params.id) {
            this.state.id = props.match.params.id
        }
    }

    lpad(value, padding) {
        var zeroes = new Array(padding+1).join("0");
        return (zeroes + value).slice(-padding);
    }

    hisUrl(url) {
        if(localStorage.getItem("route")) {
          let menu = JSON.parse(localStorage.getItem("route"));
          //console.log(menu.length+"-------------")
          if(menu.length === "0") {
            let data = ["/"];
            localStorage.setItem("route", JSON.stringify(data) );
          }
           if(menu.length > 0) {
              //console.log(menu[menu.length - 1] + "-" + url )
                if(menu[menu.length - 2] === url ){
                    //console.log("first");
                    menu.pop();
                    //window.BPdata.route = JSON.stringify(menu);
                    localStorage.setItem("route", JSON.stringify(menu) );
                    //localStorage.setItem("route", JSON.stringify(menu) );
                }
                else if(menu[menu.length-1] !== url ){
                    menu.push(url)
                    //window.BPdata.route = JSON.stringify(menu);
                    localStorage.setItem("route", JSON.stringify(menu) );
                }
                window.BPdata.preurl =  menu[menu.length-2];
            }
        }
      }

    fetchUserData() {

        const url = window.BPdata.apiUrl+'/user/id/'+this.state.id+'?time='+localStorage.getItem(window.BPdata.time);

        axios.get(url, {
          method: "GET", // *GET, POST, PUT, DELETE, etc.
          mode: "no-cors", // no-cors, cors, *same-origin
          cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
          credentials: "same-origin", // include, *same-origin, omit
          headers: {
              "Content-Type": "application/json; charset=utf-8",
              // "Content-Type": "application/x-www-form-urlencoded",
          },
          redirect: "follow", // manual, *follow, error
          referrer: "no-referrer", // no-referrer, *client
          //body: JSON.stringify(data), // body data type must match "Content-Type" header
        })
        .then(resp => {
          // console.log(this.data.concat(resp.data));
          //let latest_data = resp.data;
          //  console.log('-----------------------')
            //console.log(latest_data)
            //console.log(resp.data);
            this.setState({
              id : resp.data.id,
              username : resp.data.username,
              phone : resp.data.phone,
              created_at : resp.data.created_at,
              league_points : resp.data.league_points,
              max_league_points : resp.data.max_league_points,
              rank : resp.data.rank
            });

          })
          .catch(function(error) {
            //console.log(error);
          });
    }

    componentDidMount() {

        window.scrollTo(0, 0);

        // console.log(mmph.normalizeInput('+၉၅၉၇၈၄၁၂၃၄၅၆')); // returns 09784123456
        // console.log(mmph.normalizeInput('+959784123456')); // returns 09784123456
        // console.log(mmph.getTelecomName('09978412345')); // returns Ooredoo
        // console.log(mmph.getPhoneNetworkType('09978412345')); // returns GSM
        // console.log(mmph.isValidMMPhoneNumber('09978412345')); // returns true if it meets Myanmar Phone
        if(localStorage.getItem(window.BPdata.time)) {
            if(localStorage.getItem(window.BPdata.time) !== "0" ) {
              //localStorage.setItem(window.BPdata.time, true);

              } else {
                this.props.history.push("/more");
                }
          } else {
              this.props.history.push("/more");
          }

        this.fetchUserData();

        this.hisUrl('/more/account/'+this.state.id);
    }

    // componentWillUpdate() {
    //     localStorage.setItem('route', '/more/login');
    //     console.log(localStorage.getItem('route'))
    // }

    inputChangeHandler(e) {
        let form = {...this.state.form};
        form[e.target.name] = e.target.value;
        this.setState({
            form
        });
    }

    userLogout() {
        //console.log(this.state.step);

        localStorage.setItem(window.BPdata.time, 0);
        localStorage.setItem('username', "");
        this.setState({ step: "login" , message : "Successfully Log Out" });
        //this.profileBlock()
        this.viewHandler();
    }

    validatePhone() {
        let form = this.state.form
        let data
        //console.log(this.state.form.phone.length)
        if(form.phone.length > 6) {
            if(mmph.isValidMMPhoneNumber(form.phone)){
                data = {
                    phone : mmph.normalizeInput(this.state.form.phone),
                    password : this.state.form.password
                }
                //console.log(data)
                this.setState({  message : "Sending" });
                this.sendLoginApi(data);
            } else {
                this.setState({  message : "Invalid phone number" });
            }

        } else {
            //console.log(this.state.message)
            this.setState({  message : "Invalid phone number" });
        }

    }
    sendLoginApi(formdata) {
        var self = this;
        let dataurl = window.BPdata.apiUrl+'/user/login';
        axios({
            method: 'post',
            url: dataurl,
            data: formdata,
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
        })
        .then(function (response) {
            if(response.data.success) {
                self.setState({
                    message : "Successfully Login",
                    step : "profile",
                    form : {
                        username : response.data.username
                    }
                });
                localStorage.setItem(window.BPdata.time, self.state.form.phone );
                localStorage.setItem('username', response.data.username );
                self.props.history.push("/contest");
            } else {
                self.setState({  message : "Something was wrong" });
            }
            //console.log(response.data.success);
        })
        .catch(function (error) {
            //console.log(error);
        });
    }

    viewHandler() {
        if(this.state.step){
            switch(this.state.step) {
                case "login":   return this.loginBlock();
                case "home":    return this.homeBlock();
                case "profile": return this.profileBlock();
                default:        return "";
              }
        }

    }

    loginBlock() {
        return <div className="container">
                <div className="row">
                    <div className="grid-30 grid-s-100 left">
                        <div className="form-group text-left">
                            <label>Phone Number</label>
                        </div>
                    </div>
                    <div className="grid-70 grid-s-100 left">
                        <div className="form-group text-center">
                        <input type="text" className="form-control text-center" placeholder="09**********" name="phone" onChange={(e) => this.inputChangeHandler.call(this, e)} value={this.state.form.phone} /><br />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="grid-30 grid-s-100 left">
                        <div className="form-group text-left">
                            <label>Password</label>
                        </div>
                    </div>
                    <div className="grid-70 grid-s-100 left">
                        <div className="form-group text-center">
                        <input type="password" className="form-control text-center"  name="password" onChange={(e) => this.inputChangeHandler.call(this, e)} value={this.state.form.password} /><br />
                        </div>
                        <input type="submit" className="btn btn-success grid-50" value="Submit" onClick={this.validatePhone} /><br />
                    </div>
                </div>
        </div>
    }

    profileBlock() {
      return <div>
          <div className="row">
              <h2>Hi {((this.state.form.username)? this.state.form.username : "Customer")}</h2>
              <p>Welcome to WebApp</p>
              <input type="submit" className="btn btn-blue grid-50" value="Log Out" onClick={this.userLogout} />
              {/* <a className="btn btn-blue grid-50" onClick={this.userLogout}>Logout</a> */}
          </div>
      </div>
   }

    homeBlock() {
        return <div>
            <div className="row">
                <a href="/more/login" className="btn btn-success grid-50">Log in</a><br /><br />
                <a href="/more/sign-up" className="btn btn-blue grid-50">Sign up</a>
            </div>
        </div>
    }

    render() {
        return (
            <div className="page">
                <div className="page-content text-left setting-menu">
                        <ul>
                            {/* <li>User ID     - {this.state.id}</li>
                            <li>Point       - {this.state.league_points}pts</li>
                            <li>Join Date   - {this.state.created_at}</li> */}
                            {/* <li><Link to="/more/league-contest">League Contest</Link></li> */}
                            {/* <li>ID          - SP{this.lpad(1,5)} </li> */}
                            <Link  to={"/more/account/"+this.state.id+"/bill-history"}><li>Bill History <span>&gt;</span></li></Link>
                            <Link  to={"/more/account/"+this.state.id+"/league-history"}><li>League History <span>&gt;</span></li></Link>

                            {/* <li><a href="/more/league-contest">League Contest</a></li>
                            <li><a href="/more/top-soccer">Top Scocer</a></li> */}
                            {/* <li><a href="/more/gems">Gems</a></li> */}
                        </ul>
                        {/* <ul>
                            <li>User        - {localStorage.getItem('username')}</li>
                            <li>Point       - 1000 pts</li>
                            {/* <li>Rank        - Mythic</li>
                            <li>Gems        - 400</li> */}
                            {/* <li>ID          - SP00001</li> */}
                        {/* </ul>  */}
                        <table className="table">
                            <tr>
                                <td>User</td>
                                <td>{this.state.username} </td>
                            </tr>
                            <tr>
                                <td>ID</td>
                                <td>{this.state.id}</td>
                            </tr>
                            <tr>
                                <td>Point</td>
                                <td><span className="color-green">{this.state.league_points}</span></td>
                            </tr>
                            <tr>
                                <td>Highest Point</td>
                                <td><span className="color-green">{this.state.max_league_points}</span></td>
                            </tr>
                            <tr>
                                <td>Rank</td>
                                <td><span className="color-green">{this.state.rank}</span></td>
                            </tr>
                            <tr>
                                <td>Join Date</td>
                                <td>{moment(this.state.created_at, 'YYYY-MM-DD hh:mm:ss').format('DD MMM YYYY')}</td>
                            </tr>
                        </table>



                    <div className="ant-back-footer">
                        <div className="ant-back-top">
                            <div className="ant-back-top-content">
                                <Link to={window.BPdata.preurl} className="color-green" >
                            { (JSON.parse(localStorage.getItem("route")) !== null)
                            ? ((this.state.url !== "/" || JSON.parse(localStorage.getItem("route"))[JSON.parse(localStorage.getItem("route")).length-1] !== "/") ?  <img src="/img/back-arrow.png" alt="back" />: ""  ) : "" }
                            </Link>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        );
    }
}

export default AccPage;
